import { render, staticRenderFns } from "./TableOrderListPage.vue?vue&type=template&id=222806fc&"
import script from "./TableOrderListPage.vue?vue&type=script&lang=js&"
export * from "./TableOrderListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports